// SPDX-License-Identifier: AGPL-3.0-or-later
import type { Dataset } from '../types';
import { esc } from '../format';
import { buildInsights } from '../analysis';
import { navigate, openState } from '../main';
import type { ViewId } from '../main';

export function renderInsights(root: HTMLElement, data: Dataset): void {
  const insights = buildInsights(data);
  root.innerHTML = `
    <div class="view-head">
      <h2>What the data shows</h2>
      <p>Findings computed automatically from the ${data.meta.release} release. Each is a fact about imprisonment — an outcome of the justice system — not a judgement about any place or group.</p>
    </div>
    <div class="insight-grid">
      ${insights.map((it, i) => `
        <div class="insight ${it.severity}">
          <h3>${esc(it.title)}</h3>
          <p>${esc(it.body)}</p>
          ${it.view ? `<button data-i="${i}">${it.state ? 'Open detail' : 'Explore'} →</button>` : ''}
        </div>`).join('')}
    </div>
  `;
  root.querySelectorAll<HTMLButtonElement>('[data-i]').forEach((b) => {
    const it = insights[Number(b.dataset.i)];
    b.addEventListener('click', () => {
      if (it.view) navigate({ view: it.view as ViewId, state: undefined });
      if (it.state) setTimeout(() => openState(it.state!), 30);
    });
  });
}
